import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const speechDelayAge2: BlogMetaData = {
  title: '言葉が遅い2歳｜発語の目安と原因、今日からできる対処法・相談先',
  description:
    '2歳で言葉が遅いと感じたら、まず発語の目安と個人差を整理しましょう。家庭でできる関わり方と、かかりつけ医・健診・発達相談への相談目安をモンテッソーリの視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-speech-delay-age-2.webp',
  filePath: buildBlogFilePath('speech-delay-age-2'),
  category: BLOG_CATEGORY.PARENTING,
};
